// Auto-generated by scripts/sync-icons.ts. Do not edit by hand.
// Source: react-icons/hi -> HiBookOpen
import type { IconBaseProps } from "..";

export function HiBookOpen({ size, color, style, ...rest }: IconBaseProps) {
  const computedStyle = color ? { color, ...style } : style;
  const dim = size ?? "1em";
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 20 20"
      aria-hidden="true"
      width={dim}
      height={dim}
      {...rest}
      style={computedStyle}
    >
      <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z" />
    </svg>
  );
}
